import React from 'react'
import type { AuthenticatedAccount } from './types'

export const AuthenticatedAccountContext = React.createContext<AuthenticatedAccount | null>(null)
